import { useMemo } from 'react'
import { ComponentWrapper, PageHeader } from './common'
import { isNonemptyArray } from '../../framework/utils'
import type { VFC } from 'react'
import type { NavItem } from '../../framework/microAppTypes'

export type WorkflowLayoutProps = {
  navItem: NavItem
  title?: string
  subtitle?: string
  dataTestId?: string
  dataMetrics?: string
}

export const Workflow: VFC<WorkflowLayoutProps> = ({
  navItem,
  title = navItem.title,
  subtitle,
  dataTestId = `workflow-${navItem.path || navItem.key}`,
  dataMetrics,
}) => {
  const header = useMemo(() => (title ? (
    <PageHeader title={title} subtitle={subtitle} dataTestId={`${dataTestId}-header`} />
  ) : null), [title, subtitle, dataTestId])

  const renderedChildren = useMemo(() => {
    if (!isNonemptyArray(navItem.children)) {
      return null
    }
    const children = navItem.children.map((child) => (
      <ComponentWrapper
        key={child.key}
        navItem={child}
      // props
      />
    ))
    return children
  }, [navItem.children])

  return <div className='spf-flex spf-flex-col' data-testid={dataTestId} data-metrics={dataMetrics}>
    {header}
    {renderedChildren}
  </div>
}

Object.assign(Workflow, {
  lazy: false,
  layout: 'Workflow',
})

export default Workflow
